import EditorDialog from "./EditorDialog";
import { MENU_THEMES } from "../../config/menuThemes";

const ThemePickerDialog = ({ open, onClose, theme, onChange }) => (
  <EditorDialog open={open} onClose={onClose} title="ظاهر منو">
    <p className="mb-3 text-sm font-medium text-gray-700">
      ظاهری که هنگام مشاهده این منو توسط مشتریان نمایش داده می‌شود را انتخاب کنید.
    </p>
    <div className="grid gap-3 sm:grid-cols-2">
      {MENU_THEMES.map((option) => {
        const active = theme === option.key;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option.key)}
            className={`rounded-2xl border p-4 text-right transition-colors ${active ? "border-primary bg-primary/5" : "border-gray-200 hover:border-primary/40"}`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="font-bold text-gray-900">{option.label}</span>
              <span className="flex shrink-0 gap-1">
                {option.colors.map((color) => (
                  <span key={color} className="h-4 w-4 rounded-full border border-black/5" style={{ backgroundColor: color }} />
                ))}
              </span>
            </div>
            <p className="mt-2 text-xs leading-6 text-gray-500">{option.description}</p>
          </button>
        );
      })}
    </div>
    <button type="button" onClick={onClose} className="mt-6 min-h-11 w-full rounded-xl bg-secondary px-4 font-bold text-white">تمام</button>
  </EditorDialog>
);

export default ThemePickerDialog;
